/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import * as Sentry from "@sentry/react";
import React, { useContext, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { debounce } from "../../../../../utils/helper";
import { AlertStatus } from "../../../../../contants";
import Modal from "../../../../../components/common/Modal/Modal";
import InputField from "../../../../../components/common/new/InputField/InputField";
import { CommonStyles } from "../../../../../components/common/Button/commonButtonStyle";
import Button from "../../../../../components/common/Button";
import Styles from "./styles";
import { ToastAlertContext } from "../../../../../config/providers/ToastAlert";
import Examination from "../../../../../services/api/examination";
import Dropdown from "../../../../../components/common/new/Dropdown/Dropdown";

const EXAM_LEVEL = [
  { key: "Entrance", value: "ENTRANCE" },
  { key: "Introductory", value: "INTRODUCTORY" },
  { key: "Intermediate", value: "INTERMEDIATE" },
  { key: "Advanced", value: "ADVANCED" },
];

const EXAM_SUBMISSION = {
  ROLL_NUMBER: "rollNumber",
  EXAM_DATE: "examDate",
  REMARK: "remark",
  EXAM_LEVEL: "examLevel",
};

function DirectEntryModal({ open, onClose, application, onRefresh }) {
  // eslint-disable-next-line no-unused-vars
  const [applicationDate, setApplicationDate] = useState(null);

  const toast = useContext(ToastAlertContext);

  const submitReviewRequest = async (values) => {
    try {
      await Examination.ExamDirectEntry(
        {
          ...values,
          remark: values?.remark,
        },
        application?.memberId
      );

      toast.show(`Entry Created Successfully`, AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
        onClose();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <Formik
          initialValues={{ [EXAM_SUBMISSION.EXAM_DATE]: null }}
          enableReinitialize
          onSubmit={debounce(submitReviewRequest)}
        >
          {({ handleChange, values, handleSubmit, errors, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Box>
                <Typography
                  style={{
                    color: "#8C8C8C",
                    fontSize: "20px ",
                    fontWeight: "500",
                  }}
                >
                  Exam Direct Entry
                </Typography>
                <Box marginTop="10px" color="#183053">
                  <Typography />
                  <Typography variant="small" weight={500} color="#183053">
                    {/* {Object?.values(userOSNames)?.join("/")} */}
                    {[
                      application?.areaName,
                      application?.zoneName,
                      application?.regionName,
                      application?.chapterName,
                      application?.districtName,
                      application?.blockName,
                    ]
                      .filter(Boolean)
                      .join("/ ")}
                  </Typography>
                </Box>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <Grid item md={8} sm={12}>
                    <div style={{ padding: "20px 0px 0px 10px" }}>
                      <div style={{ ...Styles.gridContainer }}>
                        <div style={{ ...Styles.gridItem }}>
                          <InputField value={application?.fullName} disabled />
                        </div>
                        <div style={{ ...Styles.gridItem }}>
                          <InputField value={application?.memberId} disabled />
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <Dropdown
                            required
                            inputProps={{ required: true }}
                            name={EXAM_SUBMISSION.EXAM_LEVEL}
                            value={values[EXAM_SUBMISSION.EXAM_LEVEL]}
                            options={EXAM_LEVEL}
                            label="Exam Type"
                            onChange={handleChange}
                            showCross
                            handleClearValue={() =>
                              setFieldValue(EXAM_SUBMISSION.EXAM_LEVEL, "")
                            }
                          />
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name={EXAM_SUBMISSION.EXAM_DATE}
                              label="Exam Date"
                              inputFormat="DD/MM/YYYY"
                              maxDate={new Date()}
                              value={values?.[EXAM_SUBMISSION.EXAM_DATE]}
                              onChange={(newValues) => {
                                setFieldValue(
                                  [EXAM_SUBMISSION.EXAM_DATE],
                                  dayjs(newValues).format("YYYY-MM-DD")
                                );
                                setApplicationDate(
                                  new Date(
                                    new Date(newValues).getTime() +
                                      24 * 60 * 60 * 1000
                                  )
                                );
                              }}
                              renderInput={(params) => (
                                <InputField {...params} required />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Roll Number"
                            name={EXAM_SUBMISSION.ROLL_NUMBER}
                            value={values[EXAM_SUBMISSION.ROLL_NUMBER]}
                            error={errors[EXAM_SUBMISSION.ROLL_NUMBER]}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </div>
                <Box mt={7}>
                  <InputField
                    type="text"
                    defaultValue=""
                    key="remark"
                    name={EXAM_SUBMISSION.REMARK}
                    label="Enter your remark here..."
                    value={values[EXAM_SUBMISSION.REMARK]}
                    onChange={handleChange}
                    InputProps={{ sx: { minHeight: "91px" } }}
                    style={{
                      height: 91,
                      minWidth: "330",
                      maxWidth: "400",
                      borderRadius: "5px",
                    }}
                  />
                </Box>
                <div
                  style={{
                    display: "flex",
                    gap: 5,
                    padding: "10px 0px 0px 10px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={CommonStyles.buttonStyle}
                    type="submit"
                    label="Submit"
                  />
                  <Button
                    variant="outlined"
                    style={{
                      ...CommonStyles.buttonStyle,
                      marginLeft: "20px",
                    }}
                    onClick={onClose}
                    label="CANCEL"
                  />
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </Modal>
  );
}

export default DirectEntryModal;
